import { resolveRole } from './roles';

const ROLE_LABELS = {
  luxe: 'Luxe Box',
  signature: 'Signature box',
  keepsake: 'Personalised keepsake box',
  bag: 'Gift bag',
  box: 'Gift box'
};

const indexVariants = (wrapOptions) => {
  const index = new Map();
  for (const option of wrapOptions || []) {
    for (const variant of option.variants || []) index.set(variant.id, { option, variant });
  }
  return index;
};

/**
 * One summary line per cart line the choices produce, priced from the real variants,
 * so the displayed total equals what the cart charges (fixes defect 4).
 * @param {{ personalisationChoices: Array<Object>, wrapOptions: Array<Object> }} args
 */
export function buildSummaryLines({ personalisationChoices = [], wrapOptions = [] }) {
  const index = indexVariants(wrapOptions);
  const lines = [];
  for (const choice of personalisationChoices) {
    const gift = index.get(choice.vId_gift);
    if (gift) {
      lines.push({
        key: String(choice.vId_gift),
        label: ROLE_LABELS[resolveRole(gift.option)] ?? gift.option.title,
        detail: choice.text ? `Name "${choice.text}"` : '',
        amount: Number(gift.variant.price) || 0
      });
    }
    if (choice.vId_stamp) {
      const stamp = index.get(choice.vId_stamp);
      lines.push({
        key: `${choice.vId_gift}-seal`,
        label: 'Wax seal',
        detail: choice.vId_stamp_label ?? '',
        amount: stamp ? Number(stamp.variant.price) || 0 : 0
      });
    }
  }
  return lines;
}

/** @returns {number} */
export function sumChoicePrices(args) {
  const total = buildSummaryLines(args).reduce((sum, line) => sum + line.amount, 0);
  return Math.round(total * 100) / 100;
}

const INSERT_PRODUCT_KEYS = ['inserts', 'themedInserts', 'bridalInsert', 'mensInserts', 'mensThemedInserts'];

/**
 * The summary line for the insert or card being designed (visualiserSelection), worded as the old modal's
 * summary (Footer/Info): "Box insert" or "Greetings card", then the product and the variant (ALBAU-899).
 * @param {{ productKey?: string|null, variant?: any, product?: { title?: string } | null } | null} selection
 * @returns {{ key: string, label: string, detail: string, amount: number } | null} null until a priced variant is chosen
 */
export function buildVisualiserSummaryLine(selection) {
  const { productKey, variant, product } = selection || {};
  if (typeof variant?.price !== 'number') return null;
  const label = INSERT_PRODUCT_KEYS.includes(productKey) ? 'Box insert' : 'Greetings card';
  const variantTitle = [variant.public_title, variant.title].find((title) => typeof title === 'string') ?? '';
  const detail = [product?.title || `Custom ${label}`, variantTitle.replace('Image Upload / ', '')]
    .filter(Boolean)
    .join(' · ');
  return { key: `visualiser-${productKey}`, label, detail, amount: variant.price / 100 };
}
